import { render, staticRenderFns } from "./Soal.vue?vue&type=template&id=de0d1954&scoped=true"
import script from "./Soal.vue?vue&type=script&lang=js"
export * from "./Soal.vue?vue&type=script&lang=js"
import style0 from "./Soal.vue?vue&type=style&index=0&id=de0d1954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0d1954",
  null
  
)

export default component.exports